<template>
  <b-card
    v-if="data"
    no-body
    class="card-revenue-budget"
  >
    <b-row class="mx-0">
      <b-col
        md="12"
        class="revenue-report-wrapper"
      >
        <div class="d-sm-flex justify-content-between align-items-center mb-3">
          <h4 class="card-title mb-50 mb-sm-0">
            {{ ('Delivery Success Rate (DSR) KPI') }}
          </h4>
        </div>

        <vue-apex-charts
          id="eighty-kpi"
          type="bar"
          height="230"
          :options="chartOptions"
          :series="data.series"
        />
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol, VBTooltip,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    VueApexCharts,
    BCard,
    BRow,
    BCol,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      chartOptions: {
        fill: { opacity: 1 },
        chart: {
          type: 'bar',
          height: 350,
          toolbar: { show: false },
        },
        stroke: {
          width: 2,
          color: ['#ffffff'],
          show: 'true',
        },
        xaxis: {
          categories: ['>80%', '>=50%', '>=30%', '<30%'],
          labels: {
            style: {
              fontSize: '14px',
              fontFamily: 'Montserrat',
              fontWeight: 'bold',
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        plotOptions: {
          bar: {
            columnWidth: '55%',
            // endingShape: 'rounded',
          },
        },
        colors: [$themeColors.primary, $themeColors.success, $themeColors.danger],
        yaxis: {
          labels: {
            style: {
              fontSize: '0.86rem',
              fontFamily: 'Montserrat',
            },
          },
        },
      },
    }
  },
}
</script>
